import React from "react";
import "../../css/Components/DesignSystem/InputField.css";

class InputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      rawValue: props.value ? props.value.toString() : "", // Store unformatted number
      formattedValue: props.value ? this.formatNumber(props.value) : "", // Initial formatted value
    };
    this.inputRef = React.createRef(); // Track input field for cursor control
  }

  // Function to format numbers with commas
  formatNumber = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("en-US").format(value);
  };

  // Function to handle number input, maintain raw value, and format properly
  handleNumberChange = (e) => {
    let inputElement = this.inputRef.current;
    let cursorPosition = e.target.selectionStart; // Store current cursor position
    let rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    // Allow only numeric input
    if (!/^\d*$/.test(rawValue) && rawValue !== "") return;

    this.setState({ rawValue }, () => {
      let formattedValue = this.formatNumber(rawValue);

      this.setState({ formattedValue }, () => {
        // Restore cursor position after reformatting
        setTimeout(() => {
          if (inputElement) {
            let newPosition =
              cursorPosition + (formattedValue.length - rawValue.length);
            inputElement.setSelectionRange(newPosition, newPosition);
          }
        }, 0);
      });

      // Pass the **raw numeric value** to the parent component (no commas)
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: rawValue === "" ? "" : Number(rawValue),
          },
        });
      }
    });
  };

  // Handle Date Change with Weekend Restriction
  handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const dayOfWeek = selectedDate.getDay();

    if (dayOfWeek === 0 || dayOfWeek === 6) {
      this.setState({
        error: "Weekends are not allowed. Please select a weekday.",
      });
      e.target.value = "";
    } else {
      this.setState({ error: "" });
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  render() {
    const {
      title,
      placeholder,
      isTextarea,
      name,
      required,
      specialType,
      min,
      value,
      type,
      onChange,
      onClick,
      step,
    } = this.props;

    return (
      <div className={`row ${isTextarea ? "textarea-row" : ""}`}>
        <div className="Label-Medium">{title}</div>
        {isTextarea ? (
          <textarea
            name={name}
            placeholder={placeholder}
            className={`textarea-field ${value ? "Content" : "Content"}`}
            required={required}
            value={specialType === "number" ? this.state.formattedValue : value}
            onChange={
              specialType === "number" ? this.handleNumberChange : onChange
            }
          />
        ) : (
          <input
            ref={this.inputRef} // Attach ref for cursor tracking
            min={min}
            readOnly = {this.props.readOnly}
            onClick={onClick}
            step={step}
            type={
              type
                ? type
                : specialType === "number"
                ? "text"
                : specialType || "text"
            } // Use text to allow formatting
            name={name}
            placeholder={placeholder}
            className={`row-textfield ${value ? "Content" : "Content"}`}
            required={required}
            value={specialType === "number" ? this.state.formattedValue : value}
            onChange={
              specialType === "date"
                ? this.handleDateChange
                : specialType === "number"
                ? this.handleNumberChange
                : onChange
            }
          />
        )}
        {this.state.error && (
          <span className="error-message">{this.state.error}</span>
        )}
      </div>
    );
  }
}

export default InputField;
